import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import BreedHealthTestTiers from 'dpl/components/Breeds/HealthTestRequirements/Show/BreedHealthTestTiers';

function BreedHealthTestTiersContainer(props) {
  if (props.healthTestsByTier.length === 0) {
    return null;
  }

  return <BreedHealthTestTiers {...props} />;
}

BreedHealthTestTiersContainer.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  healthTestsByTier: PropTypes.array.isRequired
};

export default connect(({ server: { healthTestsByTier } }) => ({
  healthTestsByTier
}))(BreedHealthTestTiersContainer);
